import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { Store } from '@ngrx/store';
import { startLoading, stopLoading } from '../../store/loading/loading.actions';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    constructor(private store: Store) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Skip loading for background requests if needed, e.g., via headers
        if (request.headers.has('X-Skip-Loading')) {
            return next.handle(request);
        }

        this.store.dispatch(startLoading());

        return next.handle(request).pipe(
            finalize(() => {
                this.store.dispatch(stopLoading());
            })
        );
    }
}
